"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AND = void 0;
exports.AND = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: (inputs) => {
        const result = inputs.every((input) => Boolean(input));
        return { error: null, result };
    },
};
//# sourceMappingURL=and.js.map